import { IMAGE_SETTINGS, PageTemplateOptions, TEMPLATE_CONSTANTS } from '../types';

/**
 * Render header and footer template for a PDF page
 */
export const renderPageTemplate = (options: PageTemplateOptions): void => {
    
  const { pdf, entityName, pageTitle, currentPage, logoDataUrl } = options;

  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();

  // Add header to the top of the page
  pdf.setFont('helvetica', 'bold');
  pdf.setFontSize(11);
  pdf.text(entityName || '', pageWidth / 2, TEMPLATE_CONSTANTS.PAGE_MARGIN_MM, { align: 'center' });
  pdf.setLineWidth(0.4);
  pdf.setDrawColor(53, 123, 255);
  const lineWidth = pageWidth * 0.8;
  const lineStartX = pageWidth - lineWidth;
  const lineY = 15;
  pdf.line(lineStartX, lineY, lineStartX + lineWidth, lineY);
  pdf.setDrawColor(0, 0, 0);
  pdf.setLineWidth(0.2);

  // Add page title below the header
  const titleSpacingBelowLineMm = 15;
  const titleY = lineY + titleSpacingBelowLineMm;
  pdf.setFont('helvetica', 'bold');
  pdf.setFontSize(18);
  pdf.text(pageTitle || '', TEMPLATE_CONSTANTS.PAGE_MARGIN_MM, titleY, { align: 'left' });
  
  // Add footer to the bottom of the page
  const footerYMm = pageHeight - 15;
  const footerLineYMm = footerYMm - 8;

  // Draw footer blue horizontal line
  pdf.setLineWidth(0.4);
  pdf.setDrawColor(53, 123, 255);
  const footerLineStartX = 0;
  const footerLineWidth = pageWidth * 0.8;
  pdf.line(footerLineStartX, footerLineYMm, footerLineStartX + footerLineWidth, footerLineYMm);
  pdf.setDrawColor(0, 0, 0);
  pdf.setLineWidth(0.2);

  // Add logo next to the end of the line
  const logoWidthMm = 20;
  const logoHeightMm = 6;
  const logoSpacingMm = 3;
  const lineEndX = footerLineStartX + footerLineWidth;

  // Center logo vertically with the line
  const logoYMm = footerLineYMm - logoHeightMm / 2;
  const logoX = lineEndX + logoSpacingMm;

  // Add logo next to the end of the line
  if (logoDataUrl) {
    pdf.addImage(logoDataUrl, IMAGE_SETTINGS.PNG_FORMAT, logoX, logoYMm, logoWidthMm, logoHeightMm);
  }

  // Add page number aligned to the right
  const pageNumberText = `${currentPage}`;
  pdf.setFont('helvetica', 'normal');
  pdf.setFontSize(9);
  const pageNumberY = footerLineYMm + 1;
  const pageNumberX = pageWidth - TEMPLATE_CONSTANTS.PAGE_MARGIN_MM;
  pdf.text(pageNumberText, pageNumberX, pageNumberY, { align: 'right' });

  // Add centered text below the line
  pdf.setFont('helvetica', 'normal');
  pdf.setFontSize(8);
  const footerText = 'For Discussion Purposes Only - Subject to Change';
  pdf.text(footerText, pageWidth / 2, footerYMm, { align: 'center' });
};
